import { Grid } from "@mui/material"
import { memo, useEffect } from "react";
import { useResetRecoilState } from "recoil";
import LoginField from "./components/LoginField";
import PasswordLoginField from "./components/PasswordLoginField";
import { errorsReservationUserState, valuesFormReservationUserState } from "./state/atoms";

const FormLogin = memo(({ xs = 12, sm = 12, onKeyEnter }) => {
    const resetErrorsFormLogin = useResetRecoilState(errorsReservationUserState)
    const resetFormLogin = useResetRecoilState(valuesFormReservationUserState)

    useEffect(() => {
        return () => {
            resetErrorsFormLogin();
            resetFormLogin();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Grid className='animate__animated animate__fadeIn' container spacing={2}>
            <Grid item xs={xs} sm={sm}>
                <LoginField />
            </Grid>

            <Grid item xs={xs} sm={sm}>
                <PasswordLoginField onKeyEnter={onKeyEnter} />
            </Grid>
        </Grid>
    )
})

export default FormLogin;